<template>
  <horizontally-scrollable-container v-if="addedContents.length || draftContents.length">
    <table class="ui striped definition unstackable table fixed-table-width">
      <thead class="full-width">
        <tr>
          <th class="center aligned one wide"/>
          <th class="center aligned three wide">
            {{ $tc(`shortName`) }}
            <br>
            <i
              class="blue question large circle icon backoffice-tooltip"
              :data-content="$t('patients.coaching.tooltips.shortName', { contentType: $tc(contentType).toLowerCase() })"/>
          </th>
          <th class="center aligned">
            {{ $t('patients.coaching.content') }}
            <br>
            <i
              class="blue question large circle icon backoffice-tooltip"
              :data-content="$t('patients.coaching.tooltips.content', { contentType: $tc(contentType).toLowerCase() })"/>
          </th>
          <th
            v-if="contentType === 'action'"
            class="two wide center aligned">
            {{ $t('tracking') }}?
            <br>
            <i
              class="blue question large circle icon backoffice-tooltip"
              :data-content="$t('patients.coaching.tooltips.tracking', { contentType: $tc(contentType).toLowerCase() })"/>
          </th>
          <th class="two wide center aligned">
            {{ $t('startDay') }}
            <br>
            <i
              class="blue question large circle icon backoffice-tooltip"
              :data-content="$t('patients.coaching.tooltips.startDay', { contentType: $tc(contentType).toLowerCase() })"/>
          </th>
          <th
            v-if="contentType === 'action'"
            class="two wide center aligned">
            {{ $t('endDay') }}
            <br>
            <i
              class="blue question large circle icon backoffice-tooltip"
              :data-content="$t('patients.coaching.tooltips.endDay', { contentType: $tc(contentType).toLowerCase() })"/>
          </th>
          <th class="center aligned one wide"/>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in addedContents"
          :key="`added-content-${item.id}`"
          :class="{disabled: item.data.deletedStatus}">
          <td
            class="center aligned first-and-last-column">
            <i
              v-if="item.data.deletedStatus === false"
              class="lock icon"
              style="margin-right:0;"/>
          </td>
          <td>
            {{ item.data.shortName }}
          </td>
          <td>
            <div class="cell-nested-block">
              <span
                class="ui tiny label inline-label">
                {{ $tc(contentType) }}
              </span>
              <strong>{{ item.data.title }}</strong>
              <p v-html="item.data.body"/>
            </div>
            <!-- <div
              v-if="contentType === 'action'"
              class="cell-nested-block">
              <span
                class="ui tiny label inline-label">
                {{ $tc('reminder') }}
              </span>
              <strong>{{ item.data.options.reminder.title }}</strong>
              <p v-html="item.data.options.reminder.body"/>
            </div> -->
          </td>
          <td
            v-if="contentType === 'action'"
            class="center aligned">
            <i
              v-if="item.data.options.userTracking.status === true"
              class="green checkmark icon"/>
            <i
              v-if="item.data.options.userTracking.status === false"
              class="red close icon"/>
          </td>
          <td class="center aligned">
            {{ item.data.options.startDay }}
          </td>
          <td
            v-if="contentType === 'action'"
            class="center aligned">
            {{ item.data.options.endDay }}
          </td>
          <td
            class="center aligned first-and-last-column">
            <div
              class="ui circular icon button"
              style="margin-right:0;"
              v-if="item.data.deletedStatus === false"
              @click="$emit('show-deactivate-selected-added-content', item)">
              <i class="low vision icon"/>
            </div>
            <div
              v-if="item.data.deletedStatus === true"
              class="ui tiny label">
              {{ $t('patients.coaching.hidden') }}
            </div>
          </td>
        </tr>
        <tr
          v-for="(item, index) in draftContents"
          :key="`draft-content-id-${item.data.id}-index-${index}`">
          <td class="center aligned">
            <div
              class="ui circular icon button"
              style="margin-right:0;"
              @click="$emit('edit-selected-draft-content', item)">
              <i class="pencil alternate icon"/>
            </div>
          </td>
          <td>
            {{ item.data.shortName }}
          </td>
          <td>
            <i class="child icon"/>{{ $tc(contentType) }}
            <br>
            <strong>{{ item.data.title }}</strong><br>
            <span v-html="item.data.body"/>
            <template v-if="contentType === 'action'">
              <br>
              <i class="bell icon"/>{{ $tc('reminder') }}
              <br>
              <strong>{{ item.data.options.reminder.title }}</strong><br>
              <p v-html="item.data.options.reminder.body"/>
            </template>
          </td>
          <td
            v-if="contentType === 'action'"
            class="center aligned">
            <i
              v-if="item.data.options.userTracking.status === true"
              class="green checkmark icon"/>
            <i
              v-if="item.data.options.userTracking.status === false"
              class="red close icon"/>
          </td>
          <td class="center aligned">
            {{ item.data.options.startDay }}
          </td>
          <td
            v-if="contentType === 'action'"
            class="center aligned">
            {{ item.data.options.endDay }}
          </td>
          <td class="center aligned">
            <div
              class="ui circular basic icon button"
              style="margin-right:0;"
              @click="$emit('delete-one-draft-content', item)">
              <i class="trash icon"/>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </horizontally-scrollable-container>
  <div
    v-else
    class="ui small disabled placeholder segment">
    <div class="ui icon header">
      <i :class="[placeholderIcon, 'icon']"/>
      {{ $t(`patients.coaching.placeholders.${contentType}`) }}
    </div>
    <div class="inline"/>
  </div>
</template>

<script>
import HorizontallyScrollableContainer from '../utility/HorizontallyScrollableContainer'

const placeholderIcons = new Map([['action', 'tasks'], ['lesson', 'book']])

export default {
  name: 'CoachingContentsTable',
  components: { HorizontallyScrollableContainer },
  props: {
    addedContents: {
      type: Array,
      required: true
    },
    draftContents: {
      type: Array,
      required: true
    }
  },
  mounted () {
    $('.backoffice-tooltip')
      .popup()
  },
  watch: {
    draftContents (newValue, oldValue) {
      if (!oldValue.length && newValue.length) {
        this.$nextTick(
          () => {
            $('.backoffice-tooltip')
              .popup()
          }
        )
      }
    }
  },
  computed: {
    contentType () {
      return this.camelCase(this.$options.name.split('Table')[0])
    },
    placeholderIcon () {
      return placeholderIcons.get(this.contentType)
    }
  }
}
</script>

<style scoped>
.cell-nested-block:first-of-type {
  margin-top: 0 !important;
}
.cell-nested-block {
  margin-top: 0.5rem !important;
}
.inline-label {
  margin-right: 0.25rem !important;
}
.first-and-last-column {
  width: fit-content !important;
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}
.fixed-table-width {
  min-width: 905px;
}
</style>
